import { PageLayout, useBrowserTitle } from '@acp/core-ui';
import React, { Suspense } from 'react';
import { useExperiment } from '@acp/feature/auth';

const ReportedFindsPage = React.lazy(() => import('../features/reported-findings/page'));

export function ReportedFindings() {
    useBrowserTitle('Reported Findings');
    const { isLoading } = useExperiment();

    return (
        <Suspense fallback={<PageLayout.Skeleton sidebar aside controls />}>
            {/* eslint-disable-next-line no-nested-ternary */}
            {isLoading ? <PageLayout.Skeleton sidebar aside controls /> : <ReportedFindsPage />}
        </Suspense>
    );
}
